// COMPETITION CALENDAR Mixitup query filtering
// ==============================================
import mixitup from 'mixitup';
import mixitupMultiFilter from '../js/mixitup-multifilter.min.js';
import noUiSlider from "nouislider"; // For dual range slider

export const mixitupQueryString = () => {
  const competitionCalendarGroups = document.getElementsByClassName(
    'calendar__container'
  );

  interface QueryStringObject {
    competitionType?: string;
    competitionClass?: string;
    month?: string;
    competitionPara?: string;
  }

  const createQueryObjectFromString = (str: string): QueryStringObject => {
    let query: QueryStringObject = {
      competitionType: '',
      competitionClass: '',
      month: '',
      competitionPara: '',
    };

    let splitString = str.split('&');

    splitString.forEach((s) => {
      if (s.includes('tavlingstyp')) query.competitionType = s.split('=')[1];
      if (s.includes('klass=')) query.competitionClass = s.split('=')[1];
      if (s.includes('month')) query.month = s.split('=')[1];
      if (s.includes('para')) query.competitionPara = s.split('=')[1];
    });

    return query;
  };

  const createSearchString = (query: QueryStringObject): string => {
    var searchParams = new URLSearchParams(window.location.search);
    let str = '';

    if (query.competitionType != '') {
      searchParams.set('tavlingstyp', query.competitionType);
      str = searchParams.toString();
    } else {
      searchParams.delete('tavlingstyp');
      str = searchParams.toString();
    }

    if (query.competitionClass != '') {
      searchParams.set('klass', query.competitionClass);
      str = searchParams.toString();
    } else {
      searchParams.delete('klass');
      str = searchParams.toString();
    }

    if (query.competitionPara != '') {
      searchParams.set('para', query.competitionPara);
      str = searchParams.toString();
    } else {
      searchParams.delete('para');
      str = searchParams.toString();
    }

    return str;
  };

  // Update search string when filters are toggled
  // =================================================
  const updateSearchString = () => {
    let competitionTypeFilter = document.querySelector('.filter__tavlingstyp');
    let competitionTypeFilterItem = competitionTypeFilter?.querySelector('.mixitup-control-active');
    let competitionTypeFilterString = '';
    if (competitionTypeFilterItem != undefined && competitionTypeFilterItem.getAttribute('data-label-clean') != null) {
      competitionTypeFilterString += competitionTypeFilterItem.getAttribute('data-label-clean');
    }

    let competitionClassFilter = document.querySelector('.filter__klass') as HTMLElement;
    let competitionClassFilterItem = competitionClassFilter?.querySelector('.mixitup-control-active');
    let competitionClassFilterString = '';
    if (competitionClassFilterItem != undefined && competitionClassFilterItem.getAttribute('data-label-clean') != null) {
      competitionClassFilterString += competitionClassFilterItem.getAttribute('data-label-clean');
    }

    let competitionParaFilter = document.querySelector('.checkbox-filter') as HTMLElement;
    let competitionParaFilterItem = competitionParaFilter?.querySelector('.mixitup-control-active');
    let competitionParaFilterString = '';
    if (competitionParaFilterItem != undefined && competitionParaFilterItem.getAttribute('data-label-clean') != null) {
      competitionParaFilterString += competitionParaFilterItem.getAttribute('data-label-clean');
    }

    let queryObject: QueryStringObject = {
      competitionType: competitionTypeFilterString,
      competitionClass: competitionClassFilterString,
      month: '',
      competitionPara: competitionParaFilterString,
    };
    
    let queryString = createSearchString(queryObject);

    var newRelativePathQuery = window.location.pathname + '?' + queryString;
    window.history.pushState(null, '', newRelativePathQuery);

    // Go to next page
    const paginationNextElements = document.querySelectorAll(".pagination__next") as NodeListOf<HTMLAnchorElement>;
    if (paginationNextElements.length > 0) {
      Array.from(paginationNextElements).forEach((el) => {
        var newUrlType = new URL(el.href);
        var searchParams = new URLSearchParams(newUrlType.searchParams);
        const sidaSearchParam = searchParams.get("sida");
        const newLink = "?sida=" + sidaSearchParam;
        const nextElementUrl = newRelativePathQuery.replace(/\?sida=\d+/g, newLink);;
        if (searchParams == null) el.href = nextElementUrl;
      })
    };

    // Go to prev page
    const paginationPrevElements = document.querySelectorAll(".pagination__back") as NodeListOf<HTMLAnchorElement>;
    if (paginationPrevElements.length > 0) {
      Array.from(paginationPrevElements).forEach((el) => {
        var newUrlType = new URL(el.href);
        var searchParams = new URLSearchParams(newUrlType.searchParams);
        const sidaSearchParam = searchParams.get("sida");
        const newLink = "?sida=" + sidaSearchParam;
        const prevElementUrl = newRelativePathQuery.replace(/\?sida=\d+/g, newLink);;
        el.href = prevElementUrl;
      })
    };
  };

  //  Activate/set selected filters. Called when page loads
  //  @param archiveMixer - the instance of mixer
  const activateFilters = (archiveMixer: any) => {
    if (window.location.search.length > 1) {
      let locationSearch = window.location.search;

      let initialQuery: QueryStringObject = createQueryObjectFromString(locationSearch);

      if (archiveMixer != null) {
        // CompetitionType
        let competitionTypeQuery = initialQuery.competitionType;
        if (document.querySelector('[data-filter-group="tavlingstyp"]') && competitionTypeQuery.length > 0) {
          archiveMixer.setFilterGroupSelectors('tavlingstyp', '[data-type~=' + competitionTypeQuery + ']');
        }

        // CompetitionType
        let competitionClassQuery = initialQuery.competitionClass;
        if (document.querySelector('[data-filter-group="klass"]') && competitionClassQuery.length > 0) {
          archiveMixer.setFilterGroupSelectors('klass', '[data-class~=' + competitionClassQuery + ']');
        }

        // Para competiton
        let paraQuery = initialQuery.competitionPara;
        if (document.querySelector('[data-filter-group="para"]') && paraQuery.length > 0) {
          const paraFilterEl = document.querySelector('#paraCheckbox') as HTMLInputElement;
          const paraFilterGroupSelectors = paraFilterEl && paraFilterEl.value;
          archiveMixer.setFilterGroupSelectors('para', paraFilterGroupSelectors);
        }

        // Parse setFilterGroupSelectors above
        archiveMixer.parseFilterGroups();
      }
    }
  };

  /**
   * Set filter/count in dropdown label
   * @param el = container element containing filter toggles
   */
  const setActiveCount = (el: HTMLElement) => {
    if (el) {
      const countContainer = el.querySelector('.filter-counter');

      const activeFilters = el.querySelectorAll(
        '.mixitup-control-active.filter-dropdown__item'
      ) as NodeListOf<HTMLElement>;
      const allLabel = el.querySelector('.filter-all');

      let countString =
        activeFilters.length > 0 ? '(' + activeFilters.length + ')' : '';

      if (activeFilters.length < 1) {
        allLabel.classList.add('mixitup-control-active');
      }
      if (countContainer) countContainer.innerHTML = countString;
    }
  };

  /**
   * Update active filter labels
   */
  const updateActiveCount = () => {
    setActiveCount(document.querySelector('[data-filter-group="klass"]'));
    setActiveCount(document.querySelector('[data-filter-group="gren"]'));
    setActiveCount(document.querySelector('[data-filter-group="tavlingstyp"]'));
  };

  // Function to call onMixEnd
  const mixEndFunction = (state) => {
    updateSearchString();
    updateActiveCount();
  };

  let archiveMixer;
  let archiveArray = new Array();

  if (competitionCalendarGroups != undefined) {
    mixitup.use(mixitupMultiFilter);

    // Initialise archive mixers
    Array.from(competitionCalendarGroups).forEach((calendarList) => {
      if (calendarList != undefined) {
        archiveMixer = mixitup(calendarList, {
          multifilter: {
            enable: true,
          },
          animation: {
            enable: false,
          },
          selectors: {
            target: '.calendar-item',
          },
          callbacks: {
            onMixEnd: mixEndFunction,
          },
        });
        
        // Array used to loop over all mixers
        archiveArray.push(archiveMixer);

        // Set filters on load
        activateFilters(archiveMixer);
      }
    });
  }

  // Dual Range Slider
  // =====================
  // Set inital longestDistance - which is updated in filterTestResult 
  // based on the longest distance in current competitions
  let longestDistance = 50;
  const dualRangeSliderEl = document.getElementById('slider') as any;
  const dualRangeSlider = () => {
    if (!dualRangeSliderEl) return;

    const lowerValueInputEl = document.querySelector('[name="valueLower"]') as HTMLInputElement;
    const upperValueInputEl = document.querySelector('[name="valueUpper"]') as HTMLInputElement;

    // Go through all items to find the longest distance, 
    // which is then set as the dualRangeSliders max value
    const competitionItems = document.getElementsByClassName("calendar-item") as HTMLCollectionOf<HTMLElement>;
    Array.from(competitionItems).forEach((item) => {
      let distancesString = item.getAttribute('data-distance') as string;
      distancesString = distancesString.replace(/,/g, ".");
      var distances = distancesString.split(/\s+/).map(Number);
      var highest = Math.max(...distances);

      if (highest > longestDistance) {
        longestDistance = Math.round(highest);
        upperValueInputEl.value = longestDistance.toString(); 
      };
    });

    // Filter the competitions based on the dual range slider
    function filterResult(result, target) {
      let distancesString = target.dom.el.getAttribute('data-distance') as string;
      distancesString = distancesString.replace(/,/g, ".");
      var distances = distancesString.split(/\s+/).map(Number);
  
      var range = getRange();
  
      let filteredDistances = distances.filter(x => x >= range.min && x <= range.max);
  
      if (filteredDistances.length <= 0) result = false;
  
      return result;
    }
    mixitup.Mixer.registerFilter('testResultEvaluateHideShow', 'range', filterResult);
    
    // Init dual range slider
    noUiSlider.create(dualRangeSliderEl, {
      start: [0, longestDistance],
      connect: true,
      range: {
          'min': 0,
          'max': longestDistance
      }
    });

    // Update values on slider dragging
    dualRangeSliderEl.noUiSlider.on('update', function (values, handle) {
      var value = values[handle];
  
      if (handle) {
        if (upperValueInputEl) upperValueInputEl.value = Math.floor(value).toString();
      } else {
        if (lowerValueInputEl) lowerValueInputEl.value = Math.floor(value).toString();
      }
      // handleRangeInputChange();
      
      if (archiveArray) {
        archiveArray.forEach((mixer) => {
          handleRangeInputChange(mixer);
        });
      }
    });

    // Update slider on lower input change
    lowerValueInputEl.addEventListener('change', function () {
      dualRangeSliderEl.noUiSlider.set([this.value, null]);
    });

    // Update slider on upper input change
    upperValueInputEl.addEventListener('change', function () {
      dualRangeSliderEl.noUiSlider.set([null, this.value]);
    });
  }

  // Range Mixitup
  // ======================
  const minSizeRangeInput = document.querySelector('[name="valueLower"]') as HTMLInputElement;
  const maxSizeRangeInput = document.querySelector('[name="valueUpper"]') as HTMLInputElement;
  
  function getRange() {
    var min = Number(minSizeRangeInput.value);
    var max = Number(maxSizeRangeInput.value);

    return {
        min: min,
        max: max
    };
  }

  function handleRangeInputChange(mixer) {
    mixer.filter(mixer.getState().activeFilter);
  }

  // Initiate dualRangeSlider if the filter is active
  if (dualRangeSliderEl) dualRangeSlider();
};